__turbopack_context__.v({
  "actions": "verificationPanel-module-scss-module__YJrwpq__actions",
  "codeInputBox": "verificationPanel-module-scss-module__YJrwpq__codeInputBox",
  "codeInputRow": "verificationPanel-module-scss-module__YJrwpq__codeInputRow",
  "error": "verificationPanel-module-scss-module__YJrwpq__error",
  "heading": "verificationPanel-module-scss-module__YJrwpq__heading",
  "link": "verificationPanel-module-scss-module__YJrwpq__link",
  "notice": "verificationPanel-module-scss-module__YJrwpq__notice",
  "panel": "verificationPanel-module-scss-module__YJrwpq__panel",
  "subtitle": "verificationPanel-module-scss-module__YJrwpq__subtitle",
});
